import { render } from "./NewSale.vue?vue&type=template&id=6de86de8"
import script from "./NewSale.vue?vue&type=script&lang=js"
export * from "./NewSale.vue?vue&type=script&lang=js"
script.render = render

export default script